const GET_USER_PREFERENCE_QUERY = `
query getUserPreferenceQuery {
  me {
    userPreference{
      followOffer {
        followOwnOffer
        followCommentedOffer
      }
    }
  }
}
`;

export default GET_USER_PREFERENCE_QUERY;
